export default "__VITE_ASSET__b0xqm$5zEcMd2Q0C8kVUaA__"